import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";
import StyleLogin from "./files/styleLogin";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<Controller />} />
                        <Route path="/newLogin" element={<StyleLogin />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
